export const loginService = {
  apiGetOrganisationConfig() {
    let data = {
      name: "",
      shortname: "",
      tagline: "",
      logo: "self",
      colors: {
        defaultbg: "white",
        defaultText: "black",
        primary: "#FBA106",
        primaryText: "white",
        secoundary: "#692E20",
        secoundaryText: "white",
      },
    };
    return this.mokeapi(() => data, "", 2000);
  },
  apiLoginMoke() {
    let data = {
      user: {
        name: "Admin",
        role: "employee",
      },
      auth: (10).uniqueId().toString().encode(),
    };
    return this.mokeapi(() => data, <div>Logging in...</div>, 2000);
  },
  apiLogin(data) {
    return this.request(this.api().login, data)
      .exec()
      .log()
      .mapresults((response) => {
        return new Promise((resolve, reject) => {
          localStorage.setItem("token", response.data.access_token)
          this.request(
            this.api().getUser,
            {},
            {
              authorization: "Bearer " + response.data.access_token,
            }
          )
            .exec()
            .get()
            .then((userresponse) => {
              console.log("userresponse", userresponse);

              if (userresponse.data?.is_password_updated == false) {
                this.props.navigate('/open/changepassword')
              }
              let retdata = {
                auth: response.data.access_token,
                logged: {
                  ...Object.except(data, ["password"]),
                  ...response.data,
                },
                user: {
                  ...userresponse.data,
                  refresh: response.data.refresh_token,
                },
              };
              resolve(retdata);
              return retdata;
            });
        });
      })
      .get();
  },

  apiForgetPassword(data) {
    console.log("apiForgetPassword", data);
    return this.request(this.api().forgetpassword, data)
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },
  apiChangePassword(data) {
    console.log("apiChangePassword", data);
    return this.request(this.api().changepassword, data, {
      authorization: "Bearer " + localStorage.getItem('token'),
    })
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },

  apiUserSignup(data) {
    return this.request(this.api().userSignup, data)
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },

  apiCustomerLogin(data) {
    console.log("apiCustomerLogin", data);
    return this.request(this.api().customerLogin, data)
      .exec()
      .log()
      .mapresults((response) => {
        return new Promise((resolve, reject) => {
          localStorage.setItem("token", response.data.access_token)
          this.request(
            this.api().getB2cUser,
            {},
            {
              authorization: "Bearer " + response.data.access_token,
            }
          )
            .exec()
            .get()
            .then((userresponse) => {
              console.log("userresponse", userresponse);

              localStorage.setItem("is_mobile_verified", userresponse.data?.is_mobile_verified)
              if (userresponse.data?.is_mobile_verified == false) {
                this.props.navigate('/open/login')
              }
              let avatar;
              if (userresponse?.data?.profile_picture) {
                avatar =
                  this.request(this.api().fileDownloader)
                    .urltransform({ attachmentId: userresponse?.data?.profile_picture }).url +
                  "?auth=" +
                  response.data.access_token;
              } else {
                avatar = null
              }
              let retdata = {
                auth: response.data.access_token,
                logged: {
                  ...userresponse.data,
                },
                user: {
                  ...userresponse.data,
                  refresh: response.data.refresh_token,
                  avatar
                },
              };
              resolve(retdata);
              return retdata;
            });
        });
      })
      .get();
  },

  apiGenerateOTP(data) {
    return this.request(this.api().generateOtp, data)
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },

  apiOTPLogin(data) {
    console.log("apiOTPLogin", data);
    return this.request(this.api().otpLogin, data)
      .exec()
      .log()
      // .mapresults((response) => ({
      //   auth: response.data.access_token,
      //   logged: {
      //     ...response.data,
      //   },
      //   user: {
      //     ...data.user,
      //     refresh: response.data.refresh_token,
      //   },
      // }))
      .mapresults((response) => {
        return new Promise((resolve, reject) => {
          localStorage.setItem("token", response.data.access_token)
          this.request(
            this.api().getB2cUser,
            {},
            {
              authorization: "Bearer " + response.data.access_token,
            }
          )
            .exec()
            .get()
            .then((userresponse) => {
              console.log("userresponse", userresponse);

              localStorage.setItem("is_mobile_verified", userresponse.data?.is_mobile_verified)
              if (userresponse.data?.is_mobile_verified == false) {
                this.props.navigate('/open/login')
              }
              let avatar;
              if (userresponse?.data?.profile_picture) {
                avatar =
                  this.request(this.api().fileDownloader)
                    .urltransform({ attachmentId: userresponse?.data?.profile_picture }).url +
                  "?auth=" +
                  response.data.access_token;
              } else {
                avatar = null
              }
              let retdata = {
                auth: response.data.access_token,
                logged: {
                  ...userresponse.data,
                },
                user: {
                  ...userresponse.data,
                  refresh: response.data.refresh_token,
                  avatar
                },
              };
              resolve(retdata);
              return retdata;
            });
        });
      })
      .get();
  },
  apiOTPLoginVerify(data) {
    console.log({ apiOTPLoginVerify: data });

    return this.request(this.api().otpLoginVerify, data)
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },
  apiRefreshToken() {
    let refreshTokenAttemp = localStorage.getItem("refreshTokenAttemp");
    refreshTokenAttemp = refreshTokenAttemp || 1;
    localStorage.setItem("refreshTokenAttemp", +refreshTokenAttemp + 1);
    return this.request(this.api().refreshToken)
      .headers({
        refresh: app.props.store.user.refresh,
      })
      .exec()
      .log()
      .mapresults((response) => {
        let { logged = {} } = app.props.store;
        app.props.setstore("auth", response.data.access_token);
        app.props.setstore("logged", { ...logged, ...response.data });
        app.props.setstore("user.refresh", response.data.refresh_token);
        localStorage.setItem("refreshTokenAttemp", 0);
      })
      .get();
  },
  apiGetB2cUser() {

    return this.request(this.api().getB2cUser)
      .exec()
      .log()
      .mapresults((response) => {
        return {
          data: response.data,
        };
      })
      .get();
  },
  apiUpdateB2cUser(data = {}) {
    console.log({ apiUpdateB2cUser: data });

    return this.request(this.api().updateB2cUser, data)
      .exec()
      .log()
      .mapresults((response) => {
        return {
          data: response.data,
        };
      })
      .get();
  },

  apiCustomerForgetPassword(data) {
    return this.request(this.api().customerForgetPassword, data)
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },
  apiCustomerChangePassword(data) {
    return this.request(this.api().customerChangePassword, data, {
      authorization: "Bearer " + localStorage.getItem('token'),
    })
      .exec()
      .log()
      .mapresults((res) => {
        return res.data;
      })
      .get();
  },
};

export default loginService;
